import Image from 'next/image';
import { useMemo } from 'react';

import { KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function FogoIgnitionLockedTriggerFullDetails({ trigger }: Props) {
  const networkDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        <Image src="/assets/webp/fogo.webp" alt="Fogo" width={20} height={20} />
        <span>Fogo</span>
      </div>
    );
  }, []);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
